import * as React from 'react';
import { assertNever } from 'owa-assert';
import { getSearchableAsset } from 'owa-timestream-asset-search';
import { observer } from 'mobx-react-lite';
import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import highlightTerms from '../utils/highlightTerms';
import { useKeydownSelection } from 'owa-react-hooks/lib/useKeydownSelection';
import useAddSearchResultToCanvas from '../utils/useAddSearchResultToCanvas';

export default observer(function SearchResultItemView({
    item,
    highlightSearchTerms,
}: {
    item: SearchResultItem;
    highlightSearchTerms: boolean;
}) {
    const searchableAsset = getSearchableAsset(item.type);
    const SearchView = searchableAsset?.SearchView;
    const props = {
        item: item,
    };

    const addSearchResultToCanvas = useAddSearchResultToCanvas(item.type, item);

    const onKeyDown = useKeydownSelection((e: React.KeyboardEvent<HTMLDivElement>) => {
        addSearchResultToCanvas(e.target as HTMLElement);
    }, []);

    if (!SearchView) {
        assertNever(`searchable asset ${item.type} has no SearchView` as never);
        return null;
    }

    return (
        <div ref={highlightSearchTerms ? highlightTerms : undefined} onKeyDown={onKeyDown}>
            <SearchView {...(props as React.Attributes)} />
        </div>
    );
});
